import Spinner from 'components/Spinner'
import styles from './Loading.module.css'

/**
 * A full screen loading page.
 */
const LoadingPage = () => <Spinner className={styles.loading} />

export default LoadingPage
